import React from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer,
} from "recharts";

export default function ClassPerformanceChart({ data }) {
    return (
        <div className="bg-white rounded-2xl shadow p-5">

            <ResponsiveContainer width="100%" height={380}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis dataKey="week" />
                    <YAxis label={{
                        value: 'Average Score %',
                        angle: -90,         // vertical
                        position: 'insideLeft',
                        offset: 10,
                        style: { textAnchor: 'middle', fill: '#555', fontWeight: 500 }
                    }} />
                    <Tooltip />
                    <Line
                        type="monotone"
                        dataKey="avg_score"
                        stroke="#3b82f6"
                        strokeWidth={3}
                        dot={{ r: 6 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
